// WHAT: Oura No Data Display Component
// WHY:  Simple empty state message when no Oura data is available
// DOMAIN: Health → Oura
// DEPENDENCIES: React
// RISKS:
//   - NOTE: Hardcoded German text ("Keine Daten verfügbar") - not internationalized

import { type FC } from "react";

/**
 * WHAT:
 *   Empty state component displayed when no Oura data is available.
 *
 * WHY:
 *   Provides consistent empty state messaging across Oura components.
 *
 * BEHAVIOR:
 *   - Displays empty mailbox icon (📭) and German message
 *   - Uses muted text color for subtle appearance
 *   - Uses flexbox for icon and text alignment
 *
 * RISKS:
 *   - NOTE: Hardcoded German text - not internationalized
 *   - NOTE: No props for customization (message, icon).
 *
 * @returns JSX element displaying empty state message.
 *
 */
export const OuraNoData: FC = () => (
  <div className="text-textMuted flex items-center gap-2">📭 Keine Daten verfügbar.</div>
);
